import { InMemoryCache, ApolloClient, ApolloLink, gql, useMutation, ApolloProvider } from '@apollo/client';
export * from '@apollo/client';
import { atom, useRecoilValue, useSetRecoilState, useResetRecoilState, RecoilRoot } from 'recoil';
export * from 'recoil';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/link-error';
import { createUploadLink } from 'apollo-upload-client';
import fetch from 'cross-fetch';
import React, { createElement, Children, isValidElement, cloneElement, useState, forwardRef, useRef } from 'react';
import { Route, Redirect, useHistory, Link } from 'react-router-dom';
import queryString from 'query-string';
import { useParams, useLocation } from 'react-router';
import { use100vh } from 'react-div-100vh';
import { useId } from 'react-id-generator';
import { fontFamily, fontSize } from 'tailwindcss/defaultTheme';
import moment from 'moment';
import 'moment/locale/ko';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var inMemoryCache = new InMemoryCache();

var baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
var uri = baseUrl.charAt(baseUrl.length - 1) === '/'
    ? baseUrl + 'graphql'
    : baseUrl + '/graphql';
var errorLink = onError(function (_a) {
    var graphQLErrors = _a.graphQLErrors;
    if (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.some(function (error) { return error.message === 'Unauthorized'; })) {
        if (localStorage.length > 0) {
            localStorage.clear();
            window.location.reload();
        }
    }
});
var authLink = setContext(function (_, _a) {
    var headers = _a.headers;
    var token = localStorage.getItem('token');
    return {
        headers: __assign(__assign({}, headers), { Authorization: token ? "Bearer " + token : '' }),
    };
});
var httpLink = createUploadLink({ uri: uri, fetch: fetch });
var client = new ApolloClient({
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache: inMemoryCache,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
        },
    },
});

var Signup = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation Signup($input: SignupInput!) {\n    signup(input: $input) {\n      token\n    }\n  }\n"], ["\n  mutation Signup($input: SignupInput!) {\n    signup(input: $input) {\n      token\n    }\n  }\n"])));
var Login = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation Login($email: String!, $password: String!) {\n    login(email: $email, password: $password) {\n      token\n    }\n  }\n"], ["\n  mutation Login($email: String!, $password: String!) {\n    login(email: $email, password: $password) {\n      token\n    }\n  }\n"])));
var LoginWithKakao = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation LoginWithKakao($accessToken: String!) {\n    loginWithKakao(accessToken: $accessToken) {\n      token\n      kakaoId\n    }\n  }\n"], ["\n  mutation LoginWithKakao($accessToken: String!) {\n    loginWithKakao(accessToken: $accessToken) {\n      token\n      kakaoId\n    }\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;

var Alert = function (_a) {
    var children = _a.children, _b = _a.severity, severity = _b === void 0 ? 'success' : _b, text = _a.text, onClose = _a.onClose;
    var color = 'green';
    if (severity === 'error') {
        color = 'red';
    }
    else if (severity === 'warning') {
        color = 'yellow';
    }
    else if (severity === 'info') {
        color = 'blue';
    }
    return (React.createElement("div", { className: "flex rounded-md bg-" + color + "-50 p-4" },
        React.createElement("div", { className: "flex-shrink-0" },
            React.createElement("svg", { className: "h-5 w-5 text-" + color + "-800", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" },
                React.createElement("path", { fillRule: "evenodd", d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z", clipRule: "evenodd" }))),
        React.createElement("div", { className: "ml-3" },
            React.createElement("p", { className: "text-sm font-medium text-" + color + "-800" }, text !== null && text !== void 0 ? text : children)),
        React.createElement("div", { className: "ml-auto pl-3" },
            React.createElement("div", { className: "-mx-1.5 -my-1.5" },
                React.createElement("button", { type: "button", className: "inline-flex bg-" + color + "-50 rounded-md p-1.5 text-" + color + "-800\n                        hover:bg-" + color + "-100 focus:outline-none focus:ring-2 focus:ring-offset-2\n                        focus:ring-offset-" + color + "-50 focus:ring-" + color + "-600", onClick: function () { return onClose(); } },
                    React.createElement("span", { className: "sr-only" }, "Dismiss"),
                    React.createElement("svg", { className: "h-5 w-5", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" },
                        React.createElement("path", { fillRule: "evenodd", d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z", clipRule: "evenodd" })))))));
};

var AspectRatioImage = function (_a) {
    var children = _a.children, src = _a.src, alt = _a.alt, pb = _a.pb, _b = _a.rounded, rounded = _b === void 0 ? 'rounded-none' : _b;
    return (React.createElement("div", { className: "relative " + pb + " " + rounded + " bg-gray-50" },
        React.createElement("img", { className: "absolute w-full h-full " + rounded + " object-cover", src: src, alt: alt }),
        children));
};

var localStorageEffect = function (key) { return function (_a) {
    var setSelf = _a.setSelf, onSet = _a.onSet;
    setSelf(localStorage.getItem(key));
    onSet(function (newValue) {
        if (typeof newValue === 'string') {
            localStorage.setItem(key, newValue);
        }
        else {
            localStorage.removeItem(key);
        }
    });
}; };
var tokenState = atom({
    key: 'tokenState',
    default: null,
    effects_UNSTABLE: [localStorageEffect('token')],
});
var kakaoIdState = atom({
    key: 'kakaoIdState',
    default: null,
});
var alertState = atom({
    key: 'alertState',
    default: { open: false, severity: 'success', text: '' },
});

var useIdParam = function () {
    var params = useParams();
    var id = Number(params.id);
    return isNaN(id) ? undefined : id;
};
var useQueryParams = function () {
    var search = useLocation().search;
    return queryString.parse(search, {
        arrayFormat: 'comma',
        parseBooleans: true,
        parseNumbers: true,
    });
};
var useAuth = function () {
    var token = useRecoilValue(tokenState);
    return { authenticated: token !== null };
};
var useSignup = function (input, onError) {
    var setToken = useSetRecoilState(tokenState);
    var signup = useMutation(Signup, {
        variables: { input: input },
        onCompleted: function (_a) {
            var token = _a.signup.token;
            setToken(token);
        },
        onError: onError,
    })[0];
    return signup;
};
var useLogin = function (email, password, onError) {
    var setToken = useSetRecoilState(tokenState);
    var login = useMutation(Login, {
        variables: { email: email, password: password },
        onCompleted: function (_a) {
            var token = _a.login.token;
            setToken(token);
        },
        onError: onError,
    })[0];
    return login;
};
var useLoginWithKakao = function (onError) {
    var setToken = useSetRecoilState(tokenState);
    var setKakaoId = useSetRecoilState(kakaoIdState);
    var loginWithKakao = useMutation(LoginWithKakao, {
        onCompleted: function (_a) {
            var _b = _a.loginWithKakao, token = _b.token, kakaoId = _b.kakaoId;
            if (token) {
                setToken(token);
            }
            else {
                setKakaoId(kakaoId);
            }
        },
        onError: onError,
    })[0];
    return function (accessToken) {
        return loginWithKakao({
            variables: { accessToken: accessToken },
        });
    };
};
var useLoginWithKakaoWeb = function (onError) {
    var loginWithKakao = useLoginWithKakao(onError);
    return function () {
        // @ts-ignore
        return Kakao.Auth.login({
            success: function (response) {
                loginWithKakao(response.access_token);
            },
        });
    };
};
var useLogout = function () {
    var resetToken = useResetRecoilState(tokenState);
    var resetKakaoId = useResetRecoilState(kakaoIdState);
    return function () {
        resetToken();
        resetKakaoId();
    };
};
var useShowAlert = function () {
    var setAlert = useSetRecoilState(alertState);
    return function (severity, text) {
        setAlert({ open: true, severity: severity, text: text });
    };
};

var AuthRoute = function (_a) {
    var path = _a.path, Component = _a.component, _b = _a.guestOnly, guestOnly = _b === void 0 ? false : _b;
    var authenticated = useAuth().authenticated;
    return (React.createElement(Route, { path: path, render: function (_a) {
            var location = _a.location;
            if (guestOnly && authenticated) {
                return React.createElement(Redirect, { to: { pathname: '/', state: { from: location } } });
            }
            if (!guestOnly && !authenticated) {
                return (React.createElement(Redirect, { to: { pathname: '/login', state: { from: location } } }));
            }
            return React.createElement(Component, null);
        } }));
};

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 11H7.135l3.633-4.36a1 1 0 10-1.536-1.28l-5 6c-.039.047-.059.102-.088.154-.024.042-.053.078-.071.124a.985.985 0 00-.072.358L4 12l.001.004c0 .122.027.243.072.358.018.046.047.082.071.124.029.052.049.107.088.154l5 6a.999.999 0 101.536-1.28L7.135 13H19a1 1 0 000-2z",
  fill: "#262626"
});

var _ref2 = /*#__PURE__*/createElement("mask", {
  id: "icon-back_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 5,
  width: 16,
  height: 14
}, /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 11H7.135l3.633-4.36a1 1 0 10-1.536-1.28l-5 6c-.039.047-.059.102-.088.154-.024.042-.053.078-.071.124a.985.985 0 00-.072.358L4 12l.001.004c0 .122.027.243.072.358.018.046.047.082.071.124.029.052.049.107.088.154l5 6a.999.999 0 101.536-1.28L7.135 13H19a1 1 0 000-2z",
  fill: "#fff"
}));

function SvgIconBack(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("path", {
  d: "M18 6L6 18M6 6l12 12"
});

function SvgIconClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("path", {
  d: "M3 12h18M3 6h18M3 18h18"
});

function SvgIconHamburger(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/createElement("path", {
  d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
});

var _ref2$1 = /*#__PURE__*/createElement("path", {
  d: "M9 22V12h6v10"
});

function SvgIconHome(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3, _ref2$1);
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/createElement("path", {
  d: "M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9zM13.73 21a1.999 1.999 0 01-3.46 0"
});

function SvgIconNotification(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$4);
}

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/createElement("path", {
  d: "M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35"
});

function SvgIconSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$5);
}

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/createElement("path", {
  d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
});

function SvgIconAvatar(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _ref$6);
}

var Avatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 8 : _b, _c = _a.type, type = _c === void 0 ? 'circular' : _c, placeholder = _a.placeholder, src = _a.src, notification = _a.notification, _d = _a.notificationColor, notificationColor = _d === void 0 ? 'gray-300' : _d, notificationImg = _a.notificationImg, onClick = _a.onClick;
    var widthheight = "w-" + size + " h-" + size;
    var rounded = type === 'circular' ? 'rounded-full' : 'rounded-md';
    var backgroundColor = placeholder ? 'bg-gray-500' : 'bg-gray-100';
    var placeholderSize = 'text-xs';
    switch (size) {
        case 8:
            placeholderSize = 'text-sm';
            break;
        case 10:
            placeholderSize = 'text-base';
            break;
        case 12:
            placeholderSize = 'text-lg';
            break;
        case 14:
        case 16:
        case 18:
            placeholderSize = 'text-xl';
            break;
        case 20:
        case 22:
        case 24:
            placeholderSize = 'text-2xl';
            break;
    }
    var innerElement = React.createElement(React.Fragment, null);
    if (!src) {
        if (placeholder) {
            innerElement = (React.createElement("span", { className: placeholderSize + " font-medium leading-none text-white" }, placeholder));
        }
        else {
            innerElement = React.createElement(SvgIconAvatar, { className: "h-full w-full text-gray-300" });
        }
    }
    var notificationSize = size / 4;
    var notificationElement = (React.createElement("span", { className: "absolute " + notification + "-0 right-0 block\n                  w-" + notificationSize + " h-" + notificationSize + " rounded-full ring-2 ring-white\n                  bg-" + notificationColor },
        React.createElement("div", { className: "w-full h-full flex items-center justify-center" }, notificationImg)));
    return (React.createElement("span", { style: src ? { backgroundImage: "url(" + src + ")" } : {}, className: "inline-block " + widthheight + " " + rounded + " relative bg-center bg-no-repeat bg-cover " + backgroundColor, onClick: onClick },
        React.createElement("div", { className: "h-full w-full " + rounded + " overflow-hidden flex items-center justify-center" }, innerElement),
        notification && notificationElement));
};

var Banner = function (_a) {
    var src = _a.src, to = _a.to, _b = _a.height, height = _b === void 0 ? 'h-24' : _b, onClick = _a.onClick, props = __rest(_a, ["src", "to", "height", "onClick"]);
    var history = useHistory();
    var style = { width: 'calc(100vw - 2.5rem)' };
    if (src) {
        style = __assign(__assign({}, style), { backgroundImage: "url(" + src + ")" });
    }
    return (React.createElement("li", null,
        React.createElement("button", __assign({}, props, { style: style, className: "rounded-xl bg-center bg-no-repeat bg-cover bg-gray-500 " + height, onClick: to ? function () { return history.push(to); } : onClick }))));
};

var Background = function (_a) {
    var children = _a.children, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'white' : _b;
    return (React.createElement("div", { className: "fixed w-screen h-screen max-w-inherit -z-10 bg-" + backgroundColor }, children));
};

var Badge = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'basic' : _b, text = _a.text, _c = _a.removeButton, removeButton = _c === void 0 ? false : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? 'bg-gray-100' : _d, _e = _a.textColor, textColor = _e === void 0 ? 'text-gray-800' : _e;
    var badgeSize = 'px-2.5 py-0.5 text-xs';
    if (size === 'large') {
        badgeSize = 'px-3 py-0.5 text-sm';
    }
    return (React.createElement("span", { className: "inline-flex items-center " + badgeSize + " rounded-full font-medium " + backgroundColor + " " + textColor + " " + backgroundColor }, text !== null && text !== void 0 ? text : children,
        removeButton ? (React.createElement("svg", { className: "h-2 w-2", stroke: "currentColor", fill: "none", viewBox: "0 0 8 8" },
            React.createElement("path", { "stroke-linecap": "round", "stroke-width": "1.5", d: "M1 1l6 6m0-6L1 7" }))) : ('')));
};

var Blank = function (_a) {
    var text = _a.text, reversed = _a.reversed, children = _a.children;
    var vh = use100vh();
    var height = vh ? vh + "px" : '100vh';
    var backgroundColor = reversed ? 'bg-white' : 'bg-black';
    var textColor = reversed ? 'text-black' : 'text-white';
    if (!text && !children) {
        text = 'LOADING...';
    }
    return (React.createElement("div", { className: "fixed inset-0 w-full h-screen z-100 " + backgroundColor + " opacity-50 flex items-center justify-center", style: { height: height }, onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
        } },
        React.createElement("div", { className: textColor + " text-2xl" },
            text,
            " ",
            children)));
};

var BottomFixedButton = function (_a) {
    var children = _a.children, text = _a.text, to = _a.to, _b = _a.reversed, reversed = _b === void 0 ? false : _b, props = __rest(_a, ["children", "text", "to", "reversed"]);
    var backgroundColor = reversed ? 'bg-white' : 'bg-brand-1';
    var textColor = reversed ? 'text-brand-1' : 'text-white';
    var button = (React.createElement("button", __assign({}, props, { className: "fixed bottom-0 w-full max-w-inherit h-12\n                  " + backgroundColor + " " + textColor + " disabled:bg-gray-300" }), text !== null && text !== void 0 ? text : children));
    return to ? React.createElement(Link, { to: to, children: button }) : button;
};

var BottomFixedView = function (_a) {
    var children = _a.children, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'bg-white' : _b;
    return (React.createElement("div", { className: "fixed bottom-0 w-full max-w-inherit " + backgroundColor }, children));
};

var BottomNavbar = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement("nav", __assign({}, props, { className: "fixed bottom-0 flex w-full max-w-inherit h-fixed-bottom border-t bg-white" }), children));
};

var BottomNavbarItem = function (_a) {
    var Icon = _a.icon, label = _a.label, _b = _a.theme, theme = _b === void 0 ? 'brand-1' : _b, active = _a.active, props = __rest(_a, ["icon", "label", "theme", "active"]);
    var textColor = active ? "text-" + theme : 'text-gray-500';
    var iconColor = active ? "text-" + theme : 'text-gray-300';
    return (React.createElement("button", __assign({}, props, { className: "flex-1 flex flex-col items-center h-12 focus:ring-0 focus:outline-none outline-none" }),
        React.createElement(Icon, { className: "fill-current " + iconColor }),
        React.createElement("span", { className: "font-medium text-2xs " + textColor }, label)));
};

var BoxTab = function (_a) {
    var text = _a.text, subText = _a.subText, _b = _a.theme, theme = _b === void 0 ? 'brand-1' : _b, active = _a.active, props = __rest(_a, ["text", "subText", "theme", "active"]);
    var backgroundColor = active ? "bg-" + theme : 'bg-gray-100';
    var textColor = active ? 'text-white' : 'text-gray-600';
    return (React.createElement("button", __assign({}, props, { className: "flex-1 flex flex-col justify-center items-center\n                  h-full " + backgroundColor }),
        React.createElement("span", { className: "font-bold text-sm " + textColor }, text),
        subText && React.createElement("span", { className: "text-xs " + textColor }, subText)));
};

var Button = function (_a) {
    var children = _a.children, text = _a.text, to = _a.to, _b = _a.variant, variant = _b === void 0 ? 'flat' : _b, _c = _a.height, height = _c === void 0 ? 'h-13' : _c, _d = _a.rounded, rounded = _d === void 0 ? 'rounded-lg' : _d, _e = _a.fontSize, fontSize = _e === void 0 ? 'text-base' : _e, _f = _a.theme, theme = _f === void 0 ? 'brand-1' : _f, onClick = _a.onClick, props = __rest(_a, ["children", "text", "to", "variant", "height", "rounded", "fontSize", "theme", "onClick"]);
    var history = useHistory();
    var border = variant === 'outlined' ? "border border-" + theme : 'border-0';
    var backgroundColor = variant === 'flat' ? "bg-" + theme : 'bg-white';
    var textColor = variant === 'flat' ? 'text-white' : "text-" + theme;
    var disabledBackgroundColor = variant === 'flat' ? 'bg-gray-300' : backgroundColor;
    var disabledTextColor = variant === 'flat' ? 'text-white' : 'text-gray-300';
    if (theme === 'gray-50') {
        textColor = 'text-gray-800';
    }
    if (theme === 'kakao') {
        backgroundColor = 'bg-kakao-1';
        textColor = 'text-kakao-2';
    }
    return (React.createElement("button", __assign({}, props, { className: "px-6 " + height + " " + border + " " + rounded + " " + backgroundColor + " font-bold " + fontSize + " " + textColor + "\n                  disabled:border-gray-300 disabled:" + disabledBackgroundColor + " disabled:" + disabledTextColor, onClick: to ? function () { return history.push(to); } : onClick }), text !== null && text !== void 0 ? text : children));
};

var Label = function (_a) {
    var children = _a.children, text = _a.text, htmlFor = _a.htmlFor, _b = _a.margin, margin = _b === void 0 ? 'mb-1' : _b, _c = _a.fontSize, fontSize = _c === void 0 ? 'text-sm' : _c;
    return (React.createElement("label", { htmlFor: htmlFor, className: "block " + margin + " " + fontSize + " text-gray-800" }, text !== null && text !== void 0 ? text : children));
};

var Checkbox = function (_a) {
    var label = _a.label, _b = _a.theme, theme = _b === void 0 ? 'brand-1' : _b, props = __rest(_a, ["label", "theme"]);
    var htmlId = useId(1, 'checkbox')[0];
    return (React.createElement("div", { className: "flex items-center space-x-2" },
        React.createElement("input", __assign({}, props, { id: htmlId, type: "checkbox", className: "focus:" + theme + " w-4 h-4 text-" + theme + " border-gray-300 rounded" })),
        label && (React.createElement(Label, { text: label, htmlFor: htmlId, margin: "m-0", fontSize: "text-base" }))));
};

var Chip = function (_a) {
    var text = _a.text, _b = _a.selected, selected = _b === void 0 ? false : _b, props = __rest(_a, ["text", "selected"]);
    var backgroundColor = selected ? 'bg-brand-1' : 'bg-gray-100';
    var color = selected ? 'text-white' : 'text-gray-800';
    return (React.createElement("button", __assign({}, props, { className: "px-4 py-2 rounded-full " + backgroundColor + "\n                  whitespace-nowrap text-2sm " + color }), text));
};

var Container = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8" }, children));
};

var Divider = function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? 'mx-0' : _b, _c = _a.height, height = _c === void 0 ? 'h-px' : _c;
    return React.createElement("hr", { className: margin + " " + height + " border-0 bg-gray-100" });
};

var FlexWrap = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "flex flex-wrap -m-1" }, Children.map(children, function (child) {
        if (isValidElement(child)) {
            return cloneElement(child, { style: { margin: '0.25rem' } });
        }
        return child;
    })));
};

var HorizontalScrollView = function (_a) {
    var children = _a.children, _b = _a.marginX, marginX = _b === void 0 ? 'mx-0' : _b, _c = _a.marginY, marginY = _c === void 0 ? 'my-0' : _c;
    return (React.createElement("div", { className: marginX + " " + marginY + " overflow-x-auto", style: { msOverflowStyle: 'none', scrollbarWidth: 'none' } },
        React.createElement("div", { className: "inline-block" },
            React.createElement("ul", { className: "flex items-center space-x-2 mx-5" }, children))));
};

var IconButton = function (_a) {
    var children = _a.children, icon = _a.icon, to = _a.to, props = __rest(_a, ["children", "icon", "to"]);
    var button = (React.createElement("button", __assign({}, props, { className: "flex justify-center items-center w-10 h-10" }), icon !== null && icon !== void 0 ? icon : children));
    return to ? React.createElement(Link, { to: to, children: button }) : button;
};

var BackButton = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    var history = useHistory();
    return (React.createElement(IconButton, __assign({}, props, { "data-cy": "back", icon: React.createElement(SvgIconBack, null), onClick: onClick !== null && onClick !== void 0 ? onClick : (function () { return history.goBack(); }) })));
};

var CloseButton = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    var history = useHistory();
    return (React.createElement(IconButton, __assign({}, props, { icon: React.createElement(SvgIconClose, null), onClick: onClick !== null && onClick !== void 0 ? onClick : (function () { return history.goBack(); }) })));
};

var HamburgerButton = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(IconButton, __assign({}, props, { icon: React.createElement(SvgIconHamburger, null) }));
};

var HomeButton = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    return (React.createElement(IconButton, __assign({}, props, { icon: React.createElement(SvgIconHome, null), to: onClick ? undefined : '/', onClick: onClick })));
};

var NotificationButton = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    return (React.createElement(IconButton, __assign({}, props, { icon: React.createElement(SvgIconNotification, null), to: onClick ? undefined : '/notifications', onClick: onClick })));
};

var SearchButton = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    return (React.createElement(IconButton, __assign({}, props, { icon: React.createElement(SvgIconSearch, null), to: onClick ? undefined : '/search', onClick: onClick })));
};

var List = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement("ul", __assign({}, props, { className: "flex flex-col" }), children));
};

var ListItem = function (_a) {
    var children = _a.children, to = _a.to, _b = _a.fullBorder, fullBorder = _b === void 0 ? false : _b, onClick = _a.onClick, props = __rest(_a, ["children", "to", "fullBorder", "onClick"]);
    var history = useHistory();
    var borderOuter = fullBorder ? 'border-b' : 'border-0';
    var borderInner = fullBorder ? 'border-0' : 'border-b';
    return (React.createElement("li", { className: "bg-white " + borderOuter + " focus:outline-none focus:ring-0" },
        React.createElement("button", __assign({}, props, { className: "px-5 w-full", onClick: to ? function () { return history.push(to); } : onClick }),
            React.createElement("div", { className: "py-4 " + borderInner }, children))));
};

var LoadingScreen = function () {
    return React.createElement(React.Fragment, null);
};

var TextField = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, label = _a.label, feedback = _a.feedback, props = __rest(_a, ["type", "label", "feedback"]);
    var htmlId = useId(1, 'textfield')[0];
    var input = (React.createElement("input", __assign({}, props, { id: htmlId, type: type, className: "block px-4 w-full h-12 border\n                 border-gray-200 rounded-md sm:text-sm\n                 focus:ring-0 focus:border-brand-1 placeholder-gray-400\n                 disabled:bg-gray-100 disabled:text-gray-400" })));
    return label ? (React.createElement("div", null,
        label && React.createElement(Label, { text: label, htmlFor: htmlId }),
        input,
        feedback && React.createElement("span", { className: "text-red-400 text-sm" }, feedback))) : (input);
};

var PhoneNumberField = function (_a) {
    var _b, _c, _d;
    var label = _a.label, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["label", "value", "onChange"]);
    var matched = value.match(/([0-9]{3}|[0-9]{2})([0-9]{4}|[0-9]{3})([0-9]{4})/);
    var _e = useState((_b = matched === null || matched === void 0 ? void 0 : matched[1]) !== null && _b !== void 0 ? _b : ''), number1 = _e[0], setNumber1 = _e[1];
    var _f = useState((_c = matched === null || matched === void 0 ? void 0 : matched[2]) !== null && _c !== void 0 ? _c : ''), number2 = _f[0], setNumber2 = _f[1];
    var _g = useState((_d = matched === null || matched === void 0 ? void 0 : matched[3]) !== null && _d !== void 0 ? _d : ''), number3 = _g[0], setNumber3 = _g[1];
    return (React.createElement("div", null,
        label && React.createElement(Label, { text: label }),
        React.createElement("div", { className: "flex space-x-3.5" },
            React.createElement(TextField, __assign({}, props, { type: "tel", pattern: "[0-9]{3}", maxLength: 3, placeholder: "010", value: number1, onChange: function (e) {
                    setNumber1(e.target.value);
                    e.target.value = "" + e.target.value + number2 + number3;
                    onChange(e);
                } })),
            React.createElement(TextField, __assign({}, props, { type: "tel", pattern: "[0-9]{4}", maxLength: 4, placeholder: "0000", value: number2, onChange: function (e) {
                    setNumber2(e.target.value);
                    e.target.value = "" + number1 + e.target.value + number3;
                    onChange(e);
                } })),
            React.createElement(TextField, __assign({}, props, { type: "tel", pattern: "[0-9]{4}", maxLength: 4, placeholder: "0000", value: number3, onChange: function (e) {
                    setNumber3(e.target.value);
                    e.target.value = "" + number1 + number2 + e.target.value;
                    onChange(e);
                } })))));
};

var Radio = function (_a) {
    var label = _a.label, _b = _a.theme, theme = _b === void 0 ? 'brand-1' : _b, props = __rest(_a, ["label", "theme"]);
    var htmlId = useId(1, 'radio')[0];
    return (React.createElement("div", { className: "flex items-center space-x-2" },
        React.createElement("input", __assign({}, props, { id: htmlId, type: "radio", className: "focus:" + theme + " w-4 h-4 text-" + theme + " border-gray-300" })),
        label && (React.createElement(Label, { text: label, htmlFor: htmlId, margin: "m-0", fontSize: "text-base" }))));
};

var RadioGroup = function (_a) {
    var children = _a.children, label = _a.label, _b = _a.flexDirection, flexDirection = _b === void 0 ? 'flex-col' : _b, onChange = _a.onChange, props = __rest(_a, ["children", "label", "flexDirection", "onChange"]);
    var name = useId(1, 'radiogroup')[0];
    return (React.createElement("div", __assign({}, props),
        label && React.createElement(Label, { text: label }),
        React.createElement("div", { className: "flex " + flexDirection }, Children.map(children, function (child) {
            if (isValidElement(child) && child.type === Radio) {
                return cloneElement(child, { name: name, onChange: onChange });
            }
            return child;
        }))));
};

var ReusableProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(RecoilRoot, null,
        React.createElement(ApolloProvider, { client: client }, children)));
};

var Screen = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? 'static' : _b, _c = _a.top, top = _c === void 0 ? false : _c, _d = _a.bottom, bottom = _d === void 0 ? false : _d, props = __rest(_a, ["children", "position", "top", "bottom"]);
    var vh = use100vh();
    var screenHeight = vh ? vh + "px" : '100vh';
    var height = screenHeight;
    if (top) {
        height = "calc(" + screenHeight + " - 2.75rem)";
    }
    if (bottom) {
        height = "calc(" + screenHeight + " - 3rem)";
    }
    if (top && bottom) {
        height = "calc(" + screenHeight + " - 5.75rem)";
    }
    return (React.createElement("div", __assign({}, props, { ref: ref, className: position + " flex flex-col w-full", style: { height: height } }), children));
});

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
  fill: "#52525B"
});

var _ref2$2 = /*#__PURE__*/createElement("path", {
  d: "M10.4 5.6l-4.8 4.8M5.6 5.6l4.8 4.8",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconSearchClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$7, _ref2$2);
}

var SearchField = function (_a) {
    var _b = _a.onSearch, onSearch = _b === void 0 ? function () { } : _b, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["onSearch", "value", "onChange"]);
    var input = useRef(null);
    return (React.createElement("form", { className: "flex items-center px-4 w-full h-10\n                 rounded-full border border-gray-200 focus-within:border-brand-1", onSubmit: function (e) {
            e.preventDefault();
            onSearch();
        } },
        React.createElement("input", __assign({}, props, { ref: input, className: "flex-1 text-sm outline-none focus:outline-none focus:ring-0 placeholder-gray-400", value: value, onChange: onChange })),
        value && (React.createElement("div", { className: "flex justify-center items-center -mr-2 w-10 h-10" },
            React.createElement(SvgIconSearchClose, { onClick: function () {
                    var _a, _b, _c;
                    (_b = (_a = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')) === null || _a === void 0 ? void 0 : _a.set) === null || _b === void 0 ? void 0 : _b.call(input.current, '');
                    (_c = input.current) === null || _c === void 0 ? void 0 : _c.dispatchEvent(new Event('change', { bubbles: true }));
                } })))));
};

var Section = function (_a) {
    var children = _a.children, _b = _a.flexDirection, flexDirection = _b === void 0 ? 'flex-col' : _b, _c = _a.alignItems, alignItems = _c === void 0 ? 'items-stretch' : _c, _d = _a.spaceY, spaceY = _d === void 0 ? 'space-y-4' : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? 'bg-transparent' : _e;
    return (React.createElement("section", { className: "flex " + flexDirection + " " + alignItems + " " + spaceY + " px-5 py-4 " + backgroundColor }, children));
};

var Select = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, children = _a.children, props = __rest(_a, ["label", "placeholder", "children"]);
    var htmlId = useId(1, 'select')[0];
    return (React.createElement("div", null,
        label && React.createElement(Label, { text: label, htmlFor: htmlId }),
        React.createElement("select", __assign({}, props, { id: htmlId, className: "outline-none block px-4 w-full h-12 border border-gray-200 rounded-md sm:text-sm focus:ring-0 focus:border-brand-1 placeholder-gray-400 appearance-none rounded-none focus:appearance-none focus:no-underline focus:outline-none" }),
            placeholder ? (React.createElement("option", { value: undefined, selected: true, disabled: true, hidden: true }, placeholder)) : (''),
            children)));
};

var SimpleListItem = function (_a) {
    var text = _a.text, subText = _a.subText, to = _a.to, props = __rest(_a, ["text", "subText", "to"]);
    return (React.createElement(ListItem, __assign({}, props, { to: to }),
        React.createElement("div", { className: "flex justify-between items-center space-x-3" },
            React.createElement("span", { className: "truncate font-semibold text-lsm text-gray-800" }, text),
            subText && React.createElement("span", { className: "text-xs text-gray-500" }, subText))));
};

var StickyToTop = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "sticky top-fixed-top z-50 bg-white" }, children);
};

var Tab = function (_a) {
    var text = _a.text, _b = _a.full, full = _b === void 0 ? false : _b, _c = _a.theme, theme = _c === void 0 ? 'brand-1' : _c, active = _a.active, _d = _a.fontSize, fontSize = _d === void 0 ? 'text-sm' : _d, props = __rest(_a, ["text", "full", "theme", "active", "fontSize"]);
    var flex = full ? 'flex-1' : '';
    var padding = full ? '' : 'px-2';
    var border = active ? 'border-b-2' : '';
    var bold = active ? 'font-bold' : '';
    var textColor = active ? "text-" + theme : 'text-gray-500';
    return (React.createElement("button", __assign({}, props, { className: flex + " flex justify-center min-w-max items-end " + padding }),
        React.createElement("span", { className: "flex items-center px-2 h-10 " + border + " border-" + theme + "\n                    " + bold + " " + fontSize + " " + textColor }, text)));
};

var Tabs = function (_a) {
    var children = _a.children, _b = _a.sticky, sticky = _b === void 0 ? false : _b, _c = _a.padding, padding = _c === void 0 ? 'p-0' : _c, _d = _a.height, height = _d === void 0 ? 'h-10' : _d, _e = _a.borderless, borderless = _e === void 0 ? false : _e;
    var position = sticky ? 'sticky top-fixed-top z-50' : '';
    var border = borderless ? 'border-0' : 'border-b';
    return (React.createElement("nav", { className: position + " flex overflow-x-auto " + padding + " " + height + " " + border + " bg-white", style: { msOverflowStyle: 'none', scrollbarWidth: 'none' } }, children));
};

var TextArea = function (_a) {
    var label = _a.label, props = __rest(_a, ["label"]);
    var htmlId = useId(1, 'textarea')[0];
    var textarea = (React.createElement("textarea", __assign({}, props, { id: htmlId, className: "block px-4 w-full h-48 py-2\n                 border-gray-200 rounded-md sm:text-sm\n                 focus:ring-0 focus:border-brand-1 placeholder-gray-400" })));
    return label ? (React.createElement("div", null,
        label && React.createElement(Label, { text: label, htmlFor: htmlId }),
        textarea)) : (textarea);
};

var ToggleButton = function (_a) {
    var text = _a.text, active = _a.active, props = __rest(_a, ["text", "active"]);
    return (React.createElement(Button, __assign({}, props, { text: text, height: "h-12", theme: active ? 'gray-800' : 'gray-50' })));
};

var TopNavbar = function (_a) {
    var title = _a.title, left = _a.left, right = _a.right, _b = _a.position, position = _b === void 0 ? 'sticky' : _b, _c = _a.borderless, borderless = _c === void 0 ? false : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? 'white' : _d, _e = _a.leftFlex, leftFlex = _e === void 0 ? 'flex-1' : _e, _f = _a.rightFlex, rightFlex = _f === void 0 ? 'flex-1' : _f;
    var positionAdditional = position === 'sticky' ? 'top-0' : 'top-0 left-0 right-0';
    var border = borderless ? 'border-0' : 'border-b';
    return (React.createElement("nav", { className: position + " " + positionAdditional + " z-50 flex items-center\n                  px-2 h-fixed-top " + border + " bg-" + backgroundColor },
        React.createElement("div", { className: leftFlex + " flex items-center" }, left),
        React.createElement("h1", { className: "font-bold text-gray-800" }, title),
        React.createElement("div", { className: rightFlex + " flex flex-row-reverse items-center" }, right)));
};

var TopFixedModal = function (_a) {
    var isOpen = _a.isOpen, setClose = _a.setClose, header = _a.header, children = _a.children, props = __rest(_a, ["isOpen", "setClose", "header", "children"]);
    return (React.createElement("div", __assign({}, props, { className: (isOpen
            ? 'z-100 opacity-100 scale-100 duration-100 ease-in'
            : '-z-10 opacity-0 scale-95 duration-200 ease-out') + " fixed top-0 inset-x-0 p-2 transition transform origin-top-right" }),
        React.createElement("div", { className: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50" },
            React.createElement("div", { className: "pt-5 pb-6 px-5" },
                React.createElement("div", { className: "flex items-center justify-between mb-4" },
                    header,
                    React.createElement("div", { className: "-mr-2" },
                        React.createElement("button", { type: "button", className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500", onClick: function () { return setClose(); } },
                            React.createElement("span", { className: "sr-only" }, "Close menu"),
                            React.createElement("svg", { className: "h-6 w-6", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", "aria-hidden": "true" },
                                React.createElement("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M6 18L18 6M6 6l12 12" }))))),
                children))));
};

var reusableConfig = function (config) {
    if (config.plugins === undefined)
        config.plugins = [];
    if (config.theme === undefined)
        config.theme = {};
    if (config.theme.colors === undefined)
        config.theme.colors = {};
    if (config.theme.spacing === undefined)
        config.theme.spacing = {};
    if (config.theme.fontFamily === undefined)
        config.theme.fontFamily = {};
    if (config.theme.fontFamily.sans === undefined)
        config.theme.fontFamily.sans = [];
    if (config.theme.fontSize === undefined)
        config.theme.fontSize = {};
    if (config.theme.minWidth === undefined)
        config.theme.minWidth = {};
    if (config.theme.minHeight === undefined)
        config.theme.minHeight = {};
    if (config.theme.truncate === undefined)
        config.theme.truncate = {};
    if (config.theme.truncate.lines === undefined)
        config.theme.truncate.lines = {};
    if (config.variants.backgroundColor === undefined) {
        config.variants.backgroundColor = [];
    }
    if (config.variants.borderColor === undefined) {
        config.variants.borderColor = [];
    }
    var size = {
        px: '1px',
        0: '0px',
        0.5: '0.125rem',
        1: '0.25rem',
        1.5: '0.375rem',
        2: '0.5rem',
        2.5: '0.625rem',
        3: '0.75rem',
        3.5: '0.875rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
        9: '2.25rem',
        10: '2.5rem',
        11: '2.75rem',
        12: '3rem',
        13: '3.25rem',
        14: '3.5rem',
        16: '4rem',
        18: '4.5rem',
        20: '5rem',
        24: '6rem',
        28: '7rem',
        32: '8rem',
        36: '9rem',
        40: '10rem',
        44: '11rem',
        48: '12rem',
        52: '13rem',
        56: '14rem',
        60: '15rem',
        64: '16rem',
        72: '18rem',
        80: '20rem',
        96: '24rem',
        '1/2': '50%',
        '1/3': '33.333333%',
        '2/3': '66.666667%',
        '4/3': '133.333333%',
        '1/4': '25%',
        '2/4': '50%',
        '3/4': '75%',
        '1/5': '20%',
        '2/5': '40%',
        '3/5': '60%',
        '4/5': '80%',
        '1/6': '16.666667%',
        '2/6': '33.333333%',
        '3/6': '50%',
        '4/6': '66.666667%',
        '5/6': '83.333333%',
        '1/12': '8.333333%',
        '2/12': '16.666667%',
        '3/12': '25%',
        '4/12': '33.333333%',
        '5/12': '41.666667%',
        '6/12': '50%',
        '7/12': '58.333333%',
        '8/12': '66.666667%',
        '9/12': '75%',
        '10/12': '83.333333%',
        '11/12': '91.666667%',
        full: '100%',
    };
    config.plugins = __spreadArrays(config.plugins, [
        require('@tailwindcss/forms'),
        require('tailwindcss-truncate-multiline')(),
    ]);
    config.theme.colors = __assign(__assign({}, config.theme.colors), { 'kakao-1': '#f6e24b', 'kakao-2': '#46272a' });
    config.theme.spacing = __assign(__assign(__assign({}, config.theme.spacing), size), { 'fixed-top': '2.75rem', 'fixed-bottom': '3rem' });
    config.theme.fontFamily.sans = __spreadArrays([
        '"Spoqa Han Sans"'
    ], config.theme.fontFamily.sans);
    config.theme.fontSize = __assign(__assign({}, config.theme.fontSize), { '2xs': ['0.625rem', { lineHeight: '1rem' }], '2sm': ['0.8125rem', { lineHeight: '1.125rem' }], lsm: ['0.9375rem', { lineHeight: '1.375rem' }], llg: ['1.0625rem', { lineHeight: '1.625rem' }], '2lg': ['1.1875rem', { lineHeight: '1.875rem' }] });
    config.theme.maxWidth = function (theme, _a) {
        var breakpoints = _a.breakpoints;
        return (__assign(__assign(__assign({ none: 'none', xs: '20rem', sm: '24rem', md: '28rem', lg: '32rem', xl: '36rem', '2xl': '42rem', '3xl': '48rem', '4xl': '56rem', '5xl': '64rem', '6xl': '72rem', '7xl': '80rem', min: 'min-content', max: 'max-content', prose: '65ch' }, breakpoints(theme('screens'))), size), { inherit: 'inherit' }));
    };
    config.theme.maxHeight = function (theme) { return (__assign(__assign(__assign(__assign({}, theme('spacing')), { screen: '100vh' }), size), { inherit: 'inherit' })); };
    config.theme.minWidth = __assign(__assign({}, config.theme.minWidth), size);
    config.theme.minHeight = __assign(__assign({}, config.theme.minHeight), size);
    config.theme.truncate.lines = __assign(__assign({}, config.theme.truncate.lines), { 2: '2', 3: '3', 4: '4', 5: '5' });
    config.theme.zIndex = {
        auto: 'auto',
        '-30': '-30',
        '-20': '-20',
        '-10': '-10',
        0: '0',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        70: '70',
        80: '80',
        90: '90',
        100: '100',
    };
    config.variants.backgroundColor = __spreadArrays(config.variants.backgroundColor, [
        'disabled',
    ]);
    config.variants.borderColor = __spreadArrays(config.variants.borderColor, ['disabled']);
    config.variants.textColor = __spreadArrays(config.variants.textColor, ['disabled']);
    return config;
};

var plugin = require('tailwindcss/plugin');
var reusableTailwindPlugin = {
    plugins: [
        plugin(function (_a) {
            var addBase = _a.addBase, theme = _a.theme;
            addBase({
                body: { marginBottom: theme('spacing.fixed-bottom') },
                button: {
                    '&:focus': {
                        outline: '2px solid transparent',
                        outlineOffset: '2px',
                    },
                },
                input: {
                    '&:focus': {
                        outline: '2px solid transparent',
                        outlineOffset: '2px',
                    },
                },
                textarea: {
                    '&:focus': {
                        outline: '2px solid transparent',
                        outlineOffset: '2px',
                    },
                },
            });
        }),
    ],
};

var reusableTailwindPreset = {
    theme: {
        truncate: {
            lines: {
                2: '2',
                3: '3',
                4: '4',
                5: '5',
            },
        },
        extend: {
            colors: {
                'brand-1': '#000000',
                'brand-2': '#EA5519',
                'kakao-1': '#f6e24b',
                'kakao-2': '#46272a',
            },
            spacing: {
                13: '3.25rem',
                18: '4.5rem',
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '4/3': '133.333333%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%',
                '1/12': '8.333333%',
                '2/12': '16.666667%',
                '3/12': '25%',
                '4/12': '33.333333%',
                '5/12': '41.666667%',
                '6/12': '50%',
                '7/12': '58.333333%',
                '8/12': '66.666667%',
                '9/12': '75%',
                '10/12': '83.333333%',
                '11/12': '91.666667%',
                full: '100%',
                'fixed-top': '2.75rem',
                'fixed-bottom': '3rem',
            },
            fontFamily: {
                sans: __spreadArrays(['"Spoqa Han Sans"'], fontFamily.sans),
                serif: fontFamily.serif,
                mono: fontFamily.mono,
            },
            fontSize: {
                '10': ['0.625rem', { lineHeight: '1rem' }],
                '11': ['0.6875rem', { lineHeight: '1rem' }],
                '12': fontSize.xs,
                '13': ['0.8125rem', { lineHeight: '1.125rem' }],
                '14': fontSize.sm,
                '15': ['0.9375rem', { lineHeight: '1.375rem' }],
                '16': fontSize.base,
                '17': ['1.0625rem', { lineHeight: '1.625rem' }],
                '18': fontSize.lg,
                '19': ['1.1875rem', { lineHeight: '1.875rem' }],
                '20': fontSize.xl,
                '24': fontSize['2xl'],
                '30': fontSize['3xl'],
                '36': fontSize['4xl'],
                '48': fontSize['5xl'],
                '60': fontSize['6xl'],
                '72': fontSize['7xl'],
                '96': fontSize['8xl'],
                '128': fontSize['9xl'],
            },
            maxHeight: {
                inherit: 'inherit',
            },
            maxWidth: {
                inherit: 'inherit',
            },
            zIndex: {
                '-30': '-30',
                '-20': '-20',
                '-10': '-10',
                60: '60',
                70: '70',
                80: '80',
                90: '90',
                100: '100',
            },
        },
    },
    variants: {
        extend: {
            backgroundColor: ['disabled'],
            borderColor: ['disabled'],
            textColor: ['disabled'],
        },
    },
    plugins: [
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/aspect-ratio'),
        require('tailwindcss-truncate-multiline')(),
        reusableTailwindPlugin,
    ],
};

// display timestamp: '2021-01-05T07:52:33.981Z'
var utcToLocalFormat = function (utc, format) {
    return moment.utc(utc).local().format(format);
};
var utcToLocalDatetime = function (utc) {
    return moment.utc(utc).local().format('YYYY.MM.DD H:mm');
}; // 2021.01.05 16:52
var utcToLocalDatetimeMeridiem = function (utc) {
    return moment.utc(utc).local().format('YYYY.MM.DD h:mm a');
}; // 2021.01.05 4:52 오후
var utcToLocalDate = function (utc) {
    return moment.utc(utc).local().format('YYYY.MM.DD');
}; // 2021.01.05
var utcToLocalTime = function (utc) {
    return moment.utc(utc).local().format('HH:mm');
}; // 16:52
var utcToLocalFromNow = function (utc) {
    return moment.utc(utc).local().fromNow();
}; // 한 시간 전
var utcToDaysFromNow = function (utc) {
    return moment.utc(moment.utc(utc)).diff(new Date().toUTCString(), 'days');
};

export { Alert, AspectRatioImage, AuthRoute, Avatar, SvgIconAvatar as AvatarIcon, BackButton, SvgIconBack as BackIcon, Background, Badge, Banner, Blank, BottomFixedButton, BottomFixedView, BottomNavbar, BottomNavbarItem, BoxTab, Button, Checkbox, Chip, CloseButton, SvgIconClose as CloseIcon, Container, Divider, FlexWrap, HamburgerButton, SvgIconHamburger as HamburgerIcon, HomeButton, SvgIconHome as HomeIcon, HorizontalScrollView, IconButton, Label, List, ListItem, LoadingScreen, Login, LoginWithKakao, NotificationButton, SvgIconNotification as NotificationIcon, PhoneNumberField, Radio, RadioGroup, ReusableProvider, Screen, SearchButton, SearchField, SvgIconSearch as SearchIcon, Section, Select, Signup, SimpleListItem, StickyToTop, Tab, Tabs, TextArea, TextField, ToggleButton, TopFixedModal, TopNavbar, alertState, client, kakaoIdState, reusableConfig, reusableTailwindPreset, tokenState, useAuth, useIdParam, useLogin, useLoginWithKakao, useLoginWithKakaoWeb, useLogout, useQueryParams, useShowAlert, useSignup, utcToDaysFromNow, utcToLocalDate, utcToLocalDatetime, utcToLocalDatetimeMeridiem, utcToLocalFormat, utcToLocalFromNow, utcToLocalTime };
